import { render, staticRenderFns } from "./DeptMg.vue?vue&type=template&id=a630b8a2"
import script from "./DeptMg.vue?vue&type=script&lang=js"
export * from "./DeptMg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports